import { Badge, Paper } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from "./styles"
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Lang from '../../Lang';

const Records = () => {

    const classes = useStyles()
    const scores = useSelector((state) => state.scores)
    const user = JSON.parse(localStorage.getItem("profile"))
    const myRecords = scores.myScores?.records
    const getDate = (oldDate) => {
        const newDate = new Date()
        const diffTime = Math.abs(Date.parse(oldDate) - newDate);
        const dayDiff = Math.ceil(diffTime / (1000 * 60 * 60 * 24) - 1);
        switch (dayDiff) {
            case 0:
                return "Hoy"
            case 1:
                return "Ayer"
            default:
                return `Hace ${dayDiff} días`
        }
    }

    return (
        <Paper className={classes.records}>
            <h2 className={classes.records_title}><Lang props={"Historial"} /></h2>
            {user && myRecords?.length ?
                myRecords.map((item) => {
                    return <p className={classes.records_row} >
                        {item.pts < 0 ? <ArrowDownwardIcon className={classes.arrowDown} /> : <ArrowUpwardIcon className={classes.arrowUp} />}
                        {`${item.pts} `}
                        {!item.seen ?
                            <Badge color="secondary" overlap="rectangle" badgeContent={1}>
                                {`. ${item.userName} - ${getDate(item.date)} ''`}
                            </Badge>
                            :
                            ` ${item.userName} - ${getDate(item.date)}`}
                    </p>
                }) :
                <p>-----</p>}
        </Paper>
    )
}

export default Records;
